import { useCallback, useState } from "react";
export const useForceUpdate = () => {
  const [, dispatch] = useState(true);
  const memoizedDispatch: () => void = useCallback(() => {
    dispatch((prev) => !prev);
  }, [dispatch]);
  return memoizedDispatch;
};
